export enum Frequency {
    CONTINUOUSLY = "Continuously",
    FREQUENTLY = "Frequently",
    OCCASIONALLY = "Occasionally",
    NEVER = "Never"
}